import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
export function Insights() {
  const articles = [{
    tag: 'POLICY UPDATE',
    title: 'Navigating the New Regulatory Framework for Tech Investments in Nigeria',
    date: 'October 12, 2025',
    excerpt: 'An in-depth analysis of the recent legislative shifts affecting foreign direct investment in the Nigerian technology sector and what it means for US stakeholders.',
    image: 'https://images.unsplash.com/photo-1611348586804-61bf6c080437?w=600&q=80'
  }, {
    tag: 'MARKET ANALYSIS',
    title: "Ghana's Economic Resurgence: Opportunities in Renewable Energy",
    date: 'September 28, 2025',
    excerpt: 'As Ghana accelerates its transition to sustainable power, we map the key government incentives and partnership models available for international energy firms.',
    image: 'https://images.unsplash.com/photo-1504384308090-c894fdcc538d?w=600&q=80'
  }, {
    tag: 'M&E INSIGHT',
    title: 'Data-Driven Diplomacy: Measuring Social Impact in West Africa',
    date: 'September 15, 2025',
    excerpt: 'How modern monitoring and evaluation frameworks are transforming the way corporate social responsibility initiatives are tracked and reported to shareholders.',
    image: 'https://images.unsplash.com/photo-1526304640581-d334cdbbf45e?w=600&q=80'
  }];
  return <section className="py-20 bg-cream" data-id="element-92">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-93">
        {/* Section Header */}
        <div className="text-center mb-16" data-id="element-94">
          <h2 className="font-serif text-4xl md:text-5xl text-navy font-bold mb-6" data-id="element-95">
            Insights & Policy Updates
          </h2>
          <div className="h-1 w-24 bg-gold mx-auto" data-id="element-96"></div>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-97">
          {articles.map((article, index) => <article key={index} className="group bg-white rounded-card shadow-sm border border-cream-dark overflow-hidden hover:shadow-lg transition-all duration-300 flex flex-col cursor-pointer" data-id="element-98">
              <div className="relative h-48 overflow-hidden" data-id="element-99">
                <img src={article.image} alt={article.title} className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" data-id="element-100" />
              </div>
              <div className="p-8 flex flex-col flex-grow" data-id="element-101">
                <div className="flex items-center justify-between mb-4" data-id="element-102">
                  <span className="font-sans text-xs font-bold text-gold uppercase tracking-wider" data-id="element-103">
                    {article.tag}
                  </span>
                  <span className="font-sans text-sm text-gray-400" data-id="element-104">
                    {article.date}
                  </span>
                </div>
                <h3 className="font-serif text-xl text-navy font-bold mb-4 leading-snug" data-id="element-105">
                  <span className="gold-underline" data-id="element-106">{article.title}</span>
                </h3>
                <p className="font-sans text-base text-text-muted line-clamp-3 mb-6 flex-grow" data-id="element-107">
                  {article.excerpt}
                </p>
                <div className="flex items-center text-navy font-sans font-semibold text-sm uppercase tracking-wide group-hover:text-gold transition-colors mt-auto" data-id="element-108">
                  Read Article <ArrowRightIcon className="ml-2 h-4 w-4" data-id="element-109" />
                </div>
              </div>
            </article>)}
        </div>

        <div className="mt-12 text-center" data-id="element-110">
          <button className="border-2 border-navy text-navy hover:bg-navy hover:text-white font-sans font-bold text-sm uppercase tracking-wide px-8 py-3 rounded-card transition-colors" data-id="element-111">
            View All Insights
          </button>
        </div>
      </div>
    </section>;
}